import { type ScheduledMaintenance } from "@zapai/client-sdk";

/**
 * allowAdminBypass / allowZapienBypass are handled by getActiveScheduledMaintenanceFromDB.
 */
export const handleMaintenanceRedirect = async ({
  currentPathName,
  scheduledMaintenance,
  redirectFn,
}: {
  currentPathName: string;
  scheduledMaintenance?: ScheduledMaintenance;
  // client: useRouter().replace on client
  // server: redirect
  redirectFn: (path: string) => void;
}) => {
  // Admin, login, embed, and share pages aren't restricted by downtime.
  const isAdminPage = currentPathName.startsWith("/admin");
  const isLoginPage = currentPathName.startsWith("/login");
  const isEmbedPage = currentPathName.startsWith("/embed");
  const isSharePage = currentPathName.startsWith("/share");
  if (isAdminPage || isLoginPage || isEmbedPage || isSharePage) {
    return;
  }

  const isMaintenanceActive = Boolean(scheduledMaintenance);
  const isMaintenancePage = currentPathName.includes("scheduled-maintenance");

  // If there's an active maintenance window and the user is not on the maintenance page,
  // redirect to the maintenance page (unless they can bypass)
  if (isMaintenanceActive && !isMaintenancePage) {
    redirectFn("/scheduled-maintenance");
  }

  // If there's no active maintenance window and the user is on the maintenance page,
  // redirect back to the default page.
  if (!isMaintenanceActive && isMaintenancePage) {
    redirectFn("/");
  }
};
